import { isProduction } from "./env";
export var addAnalyticsEvent = function (eventName, category, label) {
    if (!isProduction()) {
        return;
    }
    window.gtag("event", eventName, {
        event_category: category,
        event_label: label,
        value: 1,
    });
};
export var addConnectEvent = function (label, account) {
    var accountStr = account.replace("0x", "");
    addAnalyticsEvent("connectAccount", label, accountStr);
};
//# sourceMappingURL=analytics.js.map